import React from 'react';

import { Icon } from '../icons';

export const ArrowUpIcon: Icon['component'] = ({ color, style, ...props }) => {
  return (
    <svg {...props} viewBox="0 0 32 32" fill={color} style={style}>
      <polygon points="0 21 32 21 16 0" />
    </svg>
  );
};
